import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import 'styled-components';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import '../../../theme/ThemedComponentWrapper.js';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../atoms/Input/Input.js';
import '../../atoms/ToggleSwitch.js';
import '../../atoms/Table/Table.js';
import '../../atoms/Table/components/HeaderCell/HeaderCell.js';
import 'luxon';
import '@floating-ui/react';
import '../../atoms/Tooltip/components/TooltipContext.js';
import '../../atoms/Tooltip/components/TooltipContent.js';
import '../../atoms/Tooltip/components/TooltipTrigger.js';
import '../../atoms/Table/components/Pagination/Pagination.js';
import '../../atoms/layout/Stack/Stack.js';
import '../CurrencyValue/components/Value.js';
import '../../pictograms/EthPictogram.js';
import '../../pictograms/EtherScanPictogram.js';
import '../../pictograms/DebankPictogram.js';
import '../../pictograms/ZapperPictogram.js';
import '../../pictograms/DaiPictogram.js';
import '../TrendValue.js';
import '../KpiCard/KpiCard.js';
import '../Tabs/Tabs.js';
import DataTable from '../DataTable.js';
import Skeleton from '../../atoms/Skeleton.js';
import '../../charts/ChartKpis/ChartKpi.js';
import '../../charts/ChartJS.js';
import '../../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../XRay.js';
import 'ethereum-blockies-base64';

function TableSkeleton({ rows = 3, columns = 4, hasDoubleCell = false }) {
    const tableRows = useMemo(() => Array.from(Array(rows), (_, index) => ({
        index
    })), [rows]);
    const tableColumns = useMemo(() => Array.from(Array(columns), () => {
        const col = {
            header: jsx(Skeleton, { height: "2" }),
            getCell: () => jsx(Skeleton, { width: "100%", height: "2" })
        };
        if (hasDoubleCell) {
            col['getCellBottom'] = () => jsx(Skeleton, { width: "100%", height: "0" });
        }
        return col;
    }), [columns, hasDoubleCell]);
    return (jsx(DataTable, { rows: tableRows, columns: tableColumns, getKey: (row) => row.index }));
}

export { TableSkeleton as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
